import { NewGoalWithID } from 'shared/types/goal';
import * as yup from 'yup';

const schema = yup
  .object<NewGoalWithID>({
    id: yup.string().required(),
    name: yup.string().required(),
    lifeAreaId: yup.string().nullable(),
    color: yup.string().nullable(),
    startDate: yup.date().nullable(),
    deadline: yup.date().nullable(),
    image: yup
      .object({
        id: yup.string().required(),
        url: yup.string().required(),
        metadata: yup
          .object({
            source: yup.string().notRequired(),
            sourceName: yup.string().nullable().notRequired(),
            sourceURL: yup.string().nullable().notRequired(),
            authorName: yup.string().nullable().notRequired(),
            authorURL: yup.string().nullable().notRequired(),
          })
          .nullable()
          .notRequired(),
      })
      .nullable()
      .notRequired()
      .default(undefined),
  })
  .strip();

const arraySchema = yup.array().of(schema);

export const newGoalsValidation = (goals: NewGoalWithID[]) => {
  const validGoals = goals.filter((goal) => schema.isValidSync(goal));
  return arraySchema.validateSync(validGoals, {
    stripUnknown: true,
  }) as NewGoalWithID[];
};
